/* WebComponentAccordionGallerySlide template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { PlaceholderIcons } from '@cewe-designsystem/util_placeholder_icons';
import { AccordionGallerySlideComponent } from '../cwc-accordion-gallery-slide';

/**
 * Definition of  parameters that the template needs to work.
 */
interface AccordionGallerySlideTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: AccordionGallerySlideComponent;

  alwaysOpen: boolean;

  // Specify parameters that are required to be passed down to the template here.
}

const AccordionGallerySlideTemplate: FunctionalComponent<AccordionGallerySlideTemplateProps> = ({
  controller,
  alwaysOpen,
}) => (
  <Host>
    <ag2-content>
      <tab-headline data-title={controller.tabTitle}></tab-headline>

      <slot name={'background'} />

      <tab-content-box>
        <slot name={'content-headline'} />

        <tab-details>
          <slot name={'content-details'} />
        </tab-details>

        <cta onclick={() => controller.toggleState()}>
          <slot name={'content-cta'} />
        </cta>
      </tab-content-box>

      <click-target onclick={() => controller.toggleState()} />

      {alwaysOpen ? (
        ''
      ) : (
        <close onclick={() => controller.close()}>
          {/*<icon name={'close'} />*/}
          <slot name={'horizontal-accordion-close-icon'}>
            <svg viewBox={'0 0 24 24'}>{PlaceholderIcons.close()}</svg>
          </slot>
        </close>
      )}

      <content-box-toggle onclick={() => controller.toggleInfoBox()}>
        {/*<icon name={'close'} />*/}
        <slot name={'vertical-accordion-close-icon'}>
          <svg viewBox={'0 0 24 24'}>{PlaceholderIcons.close()}</svg>
        </slot>
        {/*<icon name={'info-inverted'} />*/}
        <slot name={'vertical-accordion-info-icon'}>
          <svg viewBox={'0 0 24 24'}>{PlaceholderIcons.infoInverted()}</svg>
        </slot>
      </content-box-toggle>
    </ag2-content>
  </Host>
);

export default AccordionGallerySlideTemplate;
